import React from 'react';
import AddonSummaryCard from './AddonSummaryCard';
import { useSharedDataContext } from '../SharedDataContext';
import { CommaSeprator } from '../utility/utilityFunction';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';

const PlanDetails = ({ isOpen, onClose }) => {
    const [isCopiedText, setCopiedText] = useState(false);
    const { sharedQuoteData, sharedData } = useSharedDataContext();

    const history = useHistory();

    const handleCopy = (content) => {
        navigator.clipboard.writeText(content).then(() => {
            setCopiedText(true);
            setTimeout(() => {
                setCopiedText(false);
            }, 3000);
        }).catch(err => {
            console.error('Failed to copy: ', err);
        });
    };

    const BuyNow = () => {
        history.push({
            pathname: "/proposal",
            state: {
                quoteData: sharedQuoteData,
                sharedData: sharedData
            }
        });
    };
  
    return (<>
        <div className="EditProduct CustomizePrmB">
            <div className="EditProductBody">
            <div className="row g-0">
                <div className="col-md-8 plan-details-section ">
                    <ul className="nav nav-tabs mb-3" id="planTab" role="tablist">
                        <li className="nav-item" role="presentation">
                            <button className="nav-link active" id="plan-details-tab" data-bs-toggle="tab" data-bs-target="#plan-details" type="button" role="tab" aria-controls="plan-details" aria-selected="true">Plan Details</button>
                        </li>
                    </ul>

                    <div className="tab-content left-card" id="planTabContent">
                            <div className="tab-pane fade show active " id="plan-details" role="tabpanel" aria-labelledby="plan-details-tab">

                                <h6 className="fw-bold">Basic Premium</h6>
                                <div className="mt-2">
                                    <div className="planDetailsAddons ">
                                         <div className="policy_value d-flex justify-content-between">
                                            <p className="">Premium</p>
                                            <span>₹{CommaSeprator(Math.round(sharedQuoteData.Premium))}</span>
                                        </div>
                                    </div>
                                </div>

                                {Object.values(sharedData.AddonsSelected)?.some(r=> r===true) && < h6 className="fw-bold">Selected Addons</h6>}
                            <div className="mt-2">
                                <div className="planDetailsAddons ">
                                        {sharedQuoteData.ThirdPartyAmt > 0 && <div className="policy_value d-flex justify-content-between">
                                        <p className="">Third Party Liability Cover</p>
                                        <span>₹{CommaSeprator(Math.round(sharedQuoteData.ThirdPartyAmt))}</span>
                                    </div>}
                                    {sharedQuoteData.AmtPersonalBelongingsCover > 0 && <div className="policy_value">
                                        <p className="">Lost & Stolen Cover</p>
                                        <span>₹{CommaSeprator(Math.round(sharedQuoteData.AmtPersonalBelongingsCover))}</span>
                                    </div>}
                                        {sharedData.AddonsSelected.EmergencyPetMindingCover > 0 && <div className="policy_value">
                                        <p className="">Emergency Pet Minding Cover</p>
                                        <span>₹{CommaSeprator(Math.round(sharedQuoteData.AmtEmergencyPetMinding))}</span>
                                    </div>}
                                    {sharedQuoteData.AmtVeteneryConsultationOrDoctorOnCall > 0 && <div className="policy_value">
                                        <p className="">Veterinary Consultation On Call Cover</p>
                                        <span>₹{CommaSeprator(Math.round(sharedQuoteData.AmtVeteneryConsultationOrDoctorOnCall))}</span>
                                    </div>}
                                    {sharedQuoteData.AmtFuneralCostCover > 0 && <div className="policy_value">
                                        <p className="">Funeral Cost Cover</p>
                                        <span>₹{CommaSeprator(Math.round(sharedQuoteData.AmtFuneralCostCover))}</span>
                                    </div>}
                                    {sharedQuoteData.AmtTerminalDiesease > 0 && <div className="policy_value">
                                        <p className="">Terminal Disease</p>
                                        <span>₹{CommaSeprator(Math.round(sharedQuoteData.AmtTerminalDiesease))}</span>
                                    </div>}
                                    {sharedQuoteData.AmtLongTerm > 0 && <div className="policy_value">
                                        <p className="">Long Term Cover</p>
                                        <span>₹{CommaSeprator(Math.round(sharedQuoteData.AmtLongTerm))}</span>
                                    </div>}
                                </div>
                            </div>

                                <h6 className="fw-bold">Tax</h6>
                                <div className="">
                                    <div className="planDetailsAddons ">
                                        <div className="policy_value d-flex justify-content-between">
                                            <p className="">+ GST (18%)</p>
                                            <span>₹{CommaSeprator(Math.round(sharedQuoteData.GST))}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between">
                                <h4 className="fw-bold">Total Premium</h4>
                                <h4 className="fw-bold"> ₹{CommaSeprator(Math.round(sharedQuoteData.TotalPremium))}</h4>
                                </div>
                           
                        </div>

                        <div className="tab-pane fade" id="cashless-garages" role="tabpanel" aria-labelledby="cashless-garages-tab">
                            <p>Cashless Garages information goes here...</p>
                        </div>
                    </div>
                </div>


                <div className="col-md-4 summary-section cancelBtnParent">
                        <button type="button" className="clsBtn" data-dismiss="modal" onClick={() => onClose()}>
                            <img src={require("../../assets/images/Cross.svg").default} alt="Cross Icon" />
                        </button>
                        <p className="lead-id mt-4">Lead ID: {sharedData.enquiryno} {isCopiedText ? <div class="ShowSideError"><span>Copied!!</span></div> : < span > <i className="far fa-copy" onClick={() => handleCopy(sharedData?.enquiryno) }></i></span>} </p>
                    <div className="logo-img">
                        <img src={sharedQuoteData.Logo} alt="Logo" className="img-fluid mb-2"/>
                    </div>
                        <a href={sharedQuoteData.Brochure} target="blank" className="policy-link mb-3"><i className="fas fa-file-pdf"></i> Brochure</a>
                    <div className="">
                        <div className="policy_deta">
                                <div className="policy_value">
                                <p className="">Policy Period</p>
                                <span>1 Year</span>
                            </div>
                            <div className="policy_value">
                                <p className="">Policy End Date</p>
                                <span>{sharedQuoteData?.PolicyEndDate?.split("-")?.reverse()?.join("-")}</span>
                            </div>
                            <div className="policy_value">
                                <p className="mb-1">Cover Value</p>
                                <span>₹{CommaSeprator(sharedData.SumInsured)}</span>
                            </div>
                        </div>
                        <div className="">
                            <div className="policy_value">
                                <p className="">Premium</p>
                                <span>₹{CommaSeprator(Math.round(sharedQuoteData.Premium))}</span>
                            </div>
                          {/*  <div className="ms-3">
                                {sharedQuoteData.ThirdPartyAmt > 0 && <div className="policy_value">
                                    <p className="">Third Party Liability Cover</p>
                                    <span>₹{CommaSeprator(Math.round(sharedQuoteData.ThirdPartyAmt))}</span>
                                </div>}
                                {sharedQuoteData.AmtPersonalBelongingsCover > 0 && <div className="policy_value">
                                    <p className="">Lost & Stolen Cover</p>
                                    <span>₹{CommaSeprator(Math.round(sharedQuoteData.AmtPersonalBelongingsCover))}</span>
                                </div>}
                                {sharedQuoteData.AmtEmergencyPetMinding > 0 && <div className="policy_value">
                                    <p className="">Emergency Pet Minding Cover</p>
                                    <span>₹{CommaSeprator(Math.round(sharedQuoteData.AmtEmergencyPetMinding))}</span>
                                </div>}
                                {sharedQuoteData.AmtVeteneryConsultationOrDoctorOnCall > 0 && <div className="policy_value">
                                    <p className="">Vetenery Consultation On Call Cover</p>
                                    <span>₹{CommaSeprator(Math.round(sharedQuoteData.AmtVeteneryConsultationOrDoctorOnCall))}</span>
                                </div>}
                                {sharedQuoteData.AmtFuneralCostCover > 0 && <div className="policy_value">
                                    <p className="">Funeral Cost Cover</p>
                                    <span>₹{CommaSeprator(Math.round(sharedQuoteData.AmtFuneralCostCover))}</span>
                                </div>}
                                {sharedQuoteData.AmtTerminalDiesease > 0 && <div className="policy_value">
                                    <p className="">Terminal Diesease</p>
                                    <span>₹{CommaSeprator(Math.round(sharedQuoteData.AmtTerminalDiesease))}</span>
                                </div>}
                                {sharedQuoteData.AmtLongTerm > 0 && <div className="policy_value">
                                    <p className="">Long Term Cover</p>
                                    <span>₹{CommaSeprator(Math.round(sharedQuoteData.AmtLongTerm))}</span>
                                </div>}
                            </div>*/}

                            <div className="policy_value">
                                <p className="mb-1">+ GST (18%)</p>
                                <span>₹{CommaSeprator(Math.round(sharedQuoteData.GST))}</span>
                            </div>
                        </div>
                    </div>
                        <button className=" SMCSmall   buy-now-btn mt-3" onClick={()=> BuyNow() }>Buy Now</button>
                </div>
                </div>
            </div>
        </div>
    </>);
};

export default PlanDetails;
